<ng-container *ngIf="order$ | async as order">
  <div class="scd-overview-wrapper">
    <!-- Overview summary details -->
    <div class="scd-summary-details">
      <!-- Overview cart name-->
      <div class="summary-row scd-summary-name">
        <div class="label" [ngClass]="activeLanguage$ | async">
          {{ 'cart.savedCart.overview.cartName' | cxTranslate }}
        </div>
        <app-tooltip-text
          class="value"
          [tooltipContent]="order?.savedCartData?.name"
          [content]="order?.savedCartData?.name"
          placement="bottom"
          [charactersLimit]="20"
        ></app-tooltip-text>
      </div>
      <!-- Overview cart ID-->
      <div class="summary-row">
        <div class="label">{{ 'cart.savedCart.overview.id' | cxTranslate }}</div>
        <div class="value">{{ order?.savedCartData?.code }}</div>
      </div>
      <!-- Overview date saved-->
      <div class="summary-row">
        <div class="label">{{ 'cart.savedCart.overview.dateSaved' | cxTranslate }}</div>
        <div class="value">{{ order?.savedCartData?.saveTime | date: dateFormattedView }}</div>
      </div>
      <!-- Overview created by-->
      <div class="summary-row">
        <div class="label">{{ 'cart.savedCart.overview.createdBy' | cxTranslate }}</div>
        <div class="value created-by">{{ order?.savedCartData?.savedBy?.name }}</div>
      </div>
      <!-- Overview no. of items-->
      <div class="summary-row">
        <div class="label">{{ 'cart.savedCart.overview.noOfItems' | cxTranslate }}</div>
        <div class="value">
          {{ 'cart.savedCart.overview.items' | cxTranslate: { items: order?.savedCartData?.totalItems } }}
        </div>
      </div>
      <!-- Overview total-->
      <div class="summary-row summary-total">
        <div *ngIf="(isCustomTranslationsEnabled$ | async) !== null" class="summary-label">
          {{
            'cart.savedCart.overview.total'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isCustomTranslationsEnabled$ | async,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </div>
        <div class="value" *ngIf="!showSrp">{{ order?.savedCartData?.totalPrice?.formattedValue }}</div>
      </div>
    </div>

    <!-- Overview description-->
    <div class="scd-summary-desc">
      <div class="label">{{ 'cart.savedCart.overview.desc' | cxTranslate }}</div>
      <div class="value">{{ order?.savedCartData?.description }}</div>
    </div>
    <!-- Overview description-->

    <!-- start Potential Order Promotions + Applied Order Promotions -->
    <app-potential-promotions
      [potentialPromotions]="order?.savedCartData?.potentialOrderPromotions"
      [appliedOrderPromotions]="order?.savedCartData?.appliedOrderPromotions"
      [showSrp]="showSrp"
      [savedCart]="true"
    ></app-potential-promotions>
    <!-- end Potential Order Promotions + Applied Order Promotions -->

    <div class="scd-summary-buttons">
      <!-- Overview restore cart-->
      <div
        class="button-wrapper"
        matTooltip="{{ 'buttonTooltip.saveCart.restoreCart' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        [matTooltipClass]="'button-tooltip'"
        aria-label="displays a tooltip in bottom"
        [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
      >
        <button
          class="primary-btn btn-block btn"
          type="button"
          (click)="onRestoreSavedCartModal(saveCartName, order?.savedCartData?.code, order?.savedCartData?.totalItems)"
        >
          <mat-icon svgIcon="add-to-cart"></mat-icon>
        </button>
      </div>
      <!-- Overview edit cart details-->
      <button class="secondary-btn btn-block btn" type="button" (click)="onEditCartModal()">
        {{ 'cart.savedCart.overview.editCart' | cxTranslate }}
      </button>
      <!-- Overview delete cart-->
      <button
        class="tertiary-btn btn-block btn"
        type="button"
        (click)="onDeleteSavedCartModal(order?.savedCartData?.code)"
      >
        {{ 'cart.savedCart.overview.deleteCart' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-container>
